import { render, staticRenderFns } from "./TwoFieldsOneColumn.vue?vue&type=template&id=27be3e58&scoped=true&"
import script from "./TwoFieldsOneColumn.vue?vue&type=script&lang=js&"
export * from "./TwoFieldsOneColumn.vue?vue&type=script&lang=js&"
import style0 from "./TwoFieldsOneColumn.vue?vue&type=style&index=0&id=27be3e58&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27be3e58",
  null
  
)

export default component.exports